import {useState} from 'react';
import {useQuery} from 'react-query'
import PageContent from '../../components/PageContent';
import CommonTable from '../../components/ReportTable';
import { getReportList } from '../../api/Report';
import {Filters} from "../../components/Filters";

const sortByList = [{
    label: 'Newest to Oldest',
    id: 'id,desc'
}, {
    label: 'Oldest to Newest',
    id: 'id,asc'
},
//  {
//   label: '$High to $Low',
//   id: 'reward_amount,desc'
// }, {
//   label: '$Low to $High',
//   id: 'reward_amount,asc'
// }
]

const Reports = () => {
  const [current, setCurrent] = useState(1);
  const [categories, setCategories] = useState([])
  const [sortBy, setSortBy] = useState()

  const {data, isFetching} = useQuery(['reports', current, categories, sortBy], () => getReportList({
    page: current,
    types: categories,
    sort: sortBy
  }), {
    placeholderData: {
      data: {
        total: 0,
        list: []
      }
    }
  })

  const handleFilter = ({sortBy, categories}) => {
    setCategories(categories)
    setSortBy(sortBy)
  }

  return (
    <PageContent>
      <Filters onChange={handleFilter} sortByList={sortByList} />
      <CommonTable
        data={data.data.list}
        loading={isFetching}
        pagination={{
          showSizeChanger: false,
          showQuickJumper: false,
          total: data.data.total,
          current,
          pageSize: 10,
          onChange: (page) => {
            setCurrent(page)
          },
        }}
      />
    </PageContent>
  );
};

export default Reports;
